import { MAX_NAME_LENGTH } from '@/shared/config';
import { array, object, string, mixed, InferType } from '@/shared/config/yup';

import { TRANSCRIPTOR_LANGUAGE } from '@/entities/transcriptor';

import { RecordingMethod } from './types';

export const transcriptorRecordingSchema = object({
  schemaId: string().required(),
  templateSeriesIds: array().of(string().required()).default([]),
  language: mixed<TRANSCRIPTOR_LANGUAGE>()
    .oneOf(Object.values(TRANSCRIPTOR_LANGUAGE))
    .required(),
  recordingMethod: mixed<RecordingMethod>()
    .oneOf(Object.values(RecordingMethod))
    .required(),
  selectedDevice: string().max(MAX_NAME_LENGTH),
  uploadedFile: mixed<File>().nullable(),
});

export type TranscriptorRecordingFormData = InferType<
  typeof transcriptorRecordingSchema
>;
